module.exports = __webpack_public_path__ + "static/media/fa-brands-400.9c9373d9.svg";